/**
 * 图片延迟加载
 * @requires jQuery
 * @author Tianyz
 */

/**
 * 图片延迟加载
 * 从元素的 data-img 中获取图片 url 进行显示设置
 * @param  {String} [selector='.lzy-img'] 元素的 css 选择器
 * @return {null}
 */
export default function lazyLoad(selector = '.lzy-img') {
  window.onload = function() {
    $(selector).each(function() {
      var $this = $(this);
      var imgUrl = $this.data('img');

      if (selector.charAt() === '.') {
        $this.removeClass(selector.substring(1));
      }

      if (!imgUrl) {
        return;
      }

      if (this.tagName.toUpperCase() === 'IMG') {
        $this.attr('src', imgUrl);
      } else {
        $this.css('background-image', `url(${imgUrl})`);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/utils/lazy-load.js